<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="批次号">
                                <el-input v-model="q.batchNo" placeholder="请输入批次号" :clearable="true"></el-input>
                            </el-form-item>
                            <el-form-item label="物料编码">
                                <el-input v-model="q.materialCode" placeholder="请输入物料编码" :clearable="true"></el-input>
                            </el-form-item>
                            <el-form-item label="物料名称">
                                <el-input v-model="q.materialName" placeholder="请输入物料名称" :clearable="true"></el-input>
                            </el-form-item>
                            <el-form-item label="审批状态">
                                <el-select v-model="q.status" placeholder="请选择" clearable>
                                    <el-option label="待审批" :value="0"></el-option>
                                    <el-option label="已通过" :value="1"></el-option>
                                    <el-option label="已驳回" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <el-collapse-transition>
                            <div v-show="isScreen">
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="原型号经理">
                                        <el-input v-model="q.oldUserCode" placeholder="请输入编码或名称" :clearable="true"></el-input>
                                    </el-form-item>
                                    <el-form-item label="目标型号经理">
                                        <el-input v-model="q.newUserCode" placeholder="请输入编码或名称" :clearable="true"></el-input>
                                    </el-form-item>
                                    <el-form-item label="提交日期" style="width: 50%;">
                                        <el-date-picker
                                            v-model="q.startDate"
                                            clearable
                                            type="date"
                                            value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                        <span class="w-time-to">至</span>
                                        <el-date-picker
                                            v-model="q.endDate"
                                            clearable
                                            type="date"
                                            value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="产品大类">
                                        <el-input v-model="q.cpdlName" placeholder="请输入产品大类" :clearable="true"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-collapse-transition>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-screen" @click="collapseChange">
                            <img :src="isScreen?closeScreen:drawScreen" alt="">
                            <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                        </div>
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table :data="tableData" :border="true" stripe style="width: 100%" :span-method="objectSpanMethod">
                        <el-table-column type="index" label="#" width="50"></el-table-column>
                        <el-table-column prop="batchNo" label="批次号" min-width="150"></el-table-column>
                        <el-table-column prop="materialCode" label="物料编码" min-width="120"></el-table-column>
                        <el-table-column prop="materialName" label="物料名称" min-width="150"></el-table-column>
                        <el-table-column prop="cpdlName" label="产品大类" width="120"></el-table-column>
                        <el-table-column label="原型号经理" width="160">
                            <template slot-scope="scope">{{ scope.row.oldUserName }}-{{ scope.row.oldUserCode }}</template>
                        </el-table-column>
                        <el-table-column label="目标型号经理" width="160">
                            <template slot-scope="scope">{{ scope.row.newUserName }}-{{ scope.row.newUserCode }}</template>
                        </el-table-column>
                        <el-table-column prop="status" label="审批状态" width="100">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status === 0">待审批</span>
                                <span v-else-if="scope.row.status === 1">已通过</span>
                                <span v-else-if="scope.row.status === 2">已驳回</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="cuname" label="提交人" width="100"></el-table-column>
                        <el-table-column prop="cdate" label="提交时间" min-width="160">
                            <template slot-scope="scope">
                                {{ formatDate(scope.row.cdate) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="130" fixed="right">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" class="h-tableLink h-btn"
                                           @click="handleDetail(scope.row)">详情</el-button>
                                <el-button type="text" size="small" class="h-tableLink h-btn"
                                           @click="handleTrack(scope.row)">跟踪</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel" style="margin-left: 20px;">批量导出</el-button>
                            <el-button class="h-btn h-formBtn h-bggreen"
                                       @click="showBatchModifyDialog">修改型号经理</el-button>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="query"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 批量修改型号经理弹窗组件 -->
        <batch-modify-manager-dialog 
            :visible.sync="batchModifyVisible" 
            mode="add"
            @success="handleSuccess">
        </batch-modify-manager-dialog>

        <!-- 详情弹窗 -->
        <batch-modify-manager-dialog 
            :visible.sync="detailVisible" 
            mode="detail"
            :detailBatchNo="detailBatchNo"
            :detailNewUserCode="detailNewUserCode"
            :detailNewUserName="detailNewUserName"
            :detailData="detailData">
        </batch-modify-manager-dialog>

        <!-- 审批跟踪弹窗 -->
        <viewhistory :visible.sync="showTrackDialog" v-if="showTrackDialog" :id="currentInstid"/>
    </div>
</template>

<script>
    import batchModifyManager from '@/api/chanpin/batchModifyManager'
    import BatchModifyManagerDialog from './BatchModifyManagerDialog.vue'

    export default {
        name: "batchModifyManagerList",
        components: {
            BatchModifyManagerDialog
        },
        data() {
            return {
                isScreen: false,
                closeScreen: require("@/assets/images/pimg/closeallic.png"),
                drawScreen: require("@/assets/images/pimg/dobleArr.png"),
                q: {
                    batchNo: '',
                    materialCode: '',
                    materialName: '',
                    cpdlName: '',
                    oldUserCode: '',
                    newUserCode: '',
                    status: null,
                    startDate: null,
                    endDate: null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                tableData: [],
                batchModifyVisible: false,
                detailVisible: false,
                detailBatchNo: '',
                detailNewUserCode: '',
                detailNewUserName: '',
                detailData: [],
                showTrackDialog: false,
                currentInstid: '',
                // 合并行相关
                mergeSpanArr: [],
                mergeColumns: [1, 5, 6, 7, 8, 9, 10], // 需要合并的列索引：批次号、原型号经理、目标型号经理、审批状态、提交人、提交时间、操作
            }
        },
        created() {
            this.query()
        },
        methods: {
            // 展开/收起
            collapseChange() {
                this.isScreen = !this.isScreen
            },

            // 查询
            query() {
                batchModifyManager.selectPage(this.q).then(rd => {
                    this.tableData = rd.records || []
                    this.q.total = rd.total || 0
                    this.computeMergeSpan()
                })
            },

            // 计算合并行
            computeMergeSpan() {
                this.mergeSpanArr = []
                let data = this.tableData
                for (let i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.mergeSpanArr.push(1)
                        this.pos = 0
                    } else {
                        if (data[i].batchNo === data[i - 1].batchNo) {
                            this.mergeSpanArr[this.pos] += 1
                            this.mergeSpanArr.push(0)
                        } else {
                            this.mergeSpanArr.push(1)
                            this.pos = i
                        }
                    }
                }
            },

            // 合并单元格方法
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (this.mergeColumns.includes(columnIndex)) {
                    let rowspan = this.mergeSpanArr[rowIndex] || 0
                    return {
                        rowspan: rowspan,
                        colspan: 1
                    }
                }
            },

            // 重置
            resetData() {
                this.q = {
                    batchNo: '',
                    materialCode: '',
                    materialName: '',
                    cpdlName: '',
                    oldUserCode: '',
                    newUserCode: '',
                    status: null,
                    startDate: null,
                    endDate: null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                }
                this.query()
            },

            // 格式化日期
            formatDate(date) {
                if (!date) return ''
                return this.$util.riQi(new Date(date))
            },

            // 导出Excel
            exportExcel() {
                batchModifyManager.downloadExcel(this.q)
            },

            // 显示批量修改弹窗
            showBatchModifyDialog() {
                this.batchModifyVisible = true
            },

            // 提交成功回调
            handleSuccess() {
                this.query()
            },

            // 查看详情
            handleDetail(row) {
                this.detailBatchNo = row.batchNo
                this.detailNewUserCode = row.newUserCode
                this.detailNewUserName = row.newUserName
                // 查询该批次的所有记录
                batchModifyManager.selectDetailByBatchNo(row.batchNo).then(rd => {
                    if (rd.f && rd.obj) {
                        this.detailData = rd.obj
                        this.detailVisible = true
                    }
                })
            },

            // 审批跟踪
            handleTrack(row) {
                this.currentInstid = row.instid
                this.showTrackDialog = true
            },
        }
    }
</script>

<style scoped>
    .h-content {
        padding: 20px;
    }
</style>
